import { PropsWithChildren, ReactElement } from 'react'

import Loader from '@/components/Atoms/Loader/Loader'
import {
  CartProductInterface,
  CategoryInterface,
  ConstructionSiteInterface,
  FeedProductInterface,
  NomenclatureEditorFeedProductInterface,
  OrderInterface,
  OrderProductInterface,
  OrderShortType,
  OrganisationInterface,
  UserInterface,
} from '@/types'

type ItemsWithLoadingType = {
  items:
    | ConstructionSiteInterface['constructionSiteModel'][]
    | FeedProductInterface[]
    | CartProductInterface[]
    | OrganisationInterface[]
    | UserInterface[]
    | OrderShortType[]
    | OrderInterface['orderModel'][]
    | OrderProductInterface[]
    | CategoryInterface[]
    | NomenclatureEditorFeedProductInterface[]
  loading: boolean
  loadingError: boolean | string
  loaderType?: 'modal' | 'common'
  error: ReactElement
  empty?: ReactElement
  loaderPaddingTop?: number
}

function ItemsWithLoading(props: ItemsWithLoadingType & PropsWithChildren) {
  const {
    items,
    loading,
    loadingError,
    loaderType = 'common',
    error,
    empty,
    loaderPaddingTop,
    children,
  } = props

  if (items.length && !loading) {
    return <>{children}</>
  } else if (loading) {
    return (
      <Loader
        loaderType={loaderType}
        paddingTop={loaderPaddingTop}
        isModalOpen={loading}
      />
    )
  } else if (!items.length && loadingError) {
    return error
  } else if (!items.length && !loading) {
    return empty
  }
}

export default ItemsWithLoading
